export default __webpack_public_path__ + "static/media/left-arrow.dd8ee21e.svg";